const langBasedPrograms = (programsList, listName) =>{
    try {
        const langList = programsList[listName];
        if(langList) {
            const appLanguage = localStorage.getItem("selectedAppLanguageList");
            return langList[appLanguage]
        }else{
            return listName;
        }
    }catch (e) {
        console.log(e);
        return listName;
    }
};

export default langBasedPrograms;